module.exports = __webpack_public_path__ + "static/img/WILL-BROWN.2d08bdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WILL-BROWN.jpg
// module id = kI3H
// module chunks = 0